import { Injectable } from '@angular/core';

import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FeaturesConfig } from './features-config';

@Injectable()
export class FeatureToggleService {
  showPreviewFeatures = false;
  updates = new BehaviorSubject<void>(undefined);
  constructor(
    private readonly route?: ActivatedRoute,
  ) { 
    this.applyQueryParams();
    this.route?.queryParams?.subscribe(params => this.applyQueryParams(params));
  }

  isEnabled(featureName: string): boolean {
    return FeatureToggleHelper.isEnabled(featureName);
  }

  private applyQueryParams(params: Params | undefined = this.route?.snapshot?.queryParams) {
    const preview = params?.preview;
    const wasPreview = this.showPreviewFeatures;
    this.showPreviewFeatures = !!preview || preview === '';
    if (this.showPreviewFeatures !== wasPreview) this.updates.next();
  }

}

export class FeatureToggleHelper {
  static isEnabled(featureName: string): boolean {
    const config: FeaturesConfig = FeaturesConfig.getInstance();
    return config.isEnabled(featureName);
  }
}
